// Group quote line items by door, mirroring the mobile PDF/editor logic.
// Items with a door_id/door_reference (and not flagged extra_work) group
// under that door; everything else falls into "Additional works".

export function groupQuoteItems(items = []) {
  const byDoor = new Map();
  const additional = [];

  items.forEach((it, index) => {
    const item = { ...it, _index: index };
    const isDoored = !it.extra_work && (it.door_reference || it.door_id);
    if (!isDoored) {
      additional.push(item);
      return;
    }
    const key = it.door_reference || it.door_id;
    if (!byDoor.has(key)) {
      byDoor.set(key, {
        key,
        door_reference: it.door_reference || "",
        door_location: it.door_location || "",
        door_type: it.door_type || "",
        items: [],
      });
    }
    byDoor.get(key).items.push(item);
  });

  const doorGroups = Array.from(byDoor.values()).map((g) => ({
    ...g,
    total: g.items.reduce((s, x) => s + Number(x.cost || 0) * Number(x.quantity || 1), 0),
  }));

  return {
    doorGroups,
    additional,
    additionalTotal: additional.reduce((s, x) => s + Number(x.cost || 0) * Number(x.quantity || 1), 0),
  };
}

export function lineTotal(it) {
  return Number(it.cost || 0) * Number(it.quantity || 1);
}
